'use strict';
const angular = require('angular');

/*@ngInject*/
export function BallotsService($resource) {
  return $resource('/api/ballots/:id', {
    name: '@_id'
  },{
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduu.BallotsService', [])
  .factory('BallotsService', BallotsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/ballots/ballots.service.js